export default __webpack_public_path__ + "static/media/610.4c32c972.jpg";